import React from "react";
import {
  StyleSheet,
  Text,
  TouchableOpacity,
  View,
  type ViewStyle,
} from "react-native";
import { Ionicons } from "@expo/vector-icons";

import { themes } from "../Styling/themeConfigs";

import { Spacings } from "@/styling/spacings";

const currentTheme = themes.morning;

interface ModalHeaderProps {
  title: string;
  onClose: () => void;
  customStyle?: ViewStyle;
}

function ModalHeader({
  title,
  onClose,
  customStyle,
}: ModalHeaderProps): React.JSX.Element {
  return (
    <View style={[styles.header, customStyle]}>
      <Text style={styles.title}>{title}</Text>
      <TouchableOpacity
        onPress={onClose}
        hitSlop={{ top: 8, bottom: 8, left: 8, right: 8 }}
      >
        <Ionicons name="close" size={30} color="black" />
      </TouchableOpacity>
    </View>
  );
}

const styles = StyleSheet.create({
  header: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: Spacings.s5,
  },
  title: {
    fontSize: currentTheme.typography.h1.size.mobile,
    fontWeight: "bold",
  },
});

export default ModalHeader;
